import { useSelector } from 'react-redux'

import { selectAppRoundEditDisabled, selectCanApplicationInsightsSort, selectFeatures } from '.'

export const useHasFeature = (feature: string): boolean => !!useSelector(selectFeatures)[feature]
export const useCanSortApplicationInsights = (): boolean => useSelector(selectCanApplicationInsightsSort)
export const useAppRoundEditDisabled = (): boolean => useSelector(selectAppRoundEditDisabled)

export const useConfigureUpcomingApplicationCycle = (): boolean => useHasFeature('ConfigureUpcomingApplicationCycle')
